import React from "react";
// import AccountingIcon from '@mui/icons-material/AccountBalance';
// import Production from '@mui/icons-material/Inventory';
// import SalesIcon from '@mui/icons-material/MonetizationOn';
// import MachineStatusIcon from '@mui/icons-material/PrecisionManufacturing';
import Routes from "./Routes";
import GovernanceIcon from "../../assets/images/Governance.svg";
import ProductionIcon from "../../assets/images/Production.svg";
import GraphsIcon from "../../assets/images/Graph.svg";
import ProductionDelayIcon from "../../assets/images/Delay.svg";
import MasterDashIcon from "../../assets/images/master_dash_grey.PNG";
import OnboardingIcon from "../../assets/images/Onboarding.png";
import {ReactComponent as PayrollData} from "../../assets/images/PayrollData.svg";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafetyOutlined";

//import GovernanceIcon from '@mui/icons-material/SettingsApplications';

export const SidebarData = [
  {
    title: "Governance",
    icon: <img src={GovernanceIcon} alt="Governance" />,
    link: Routes.Governence,
    id: "active",
    users: ["Admin", "AirvectorCustomer", "Manager", "Mechanic"],
    subSections: [
      {
        title: "Graphs",
        icon: <img src={GraphsIcon} alt="Graphs" />,
        link: Routes.Chart,
        id: "",
        users: ["Admin", "AirvectorCustomer", "Manager"],
      },
    ],
  },
  {
    title: "Payroll Data", // renamed to "Payroll Data"
    icon: <PayrollData fill="#737373"/>, 
    link: "/payroll",
    id: "",
    users: ["Admin", "AirvectorCustomer", "Manager"],
  },
  {
    title: "Production",
    icon: (
      <img
        src={ProductionIcon}
        alt="Production"
        style={{ transform: "scale(0.9)" }}
      />
    ),
    link: Routes.Production,
    id: "",
    users: ["Admin", "AirvectorCustomer", "Manager", "Production"],
    subSections: [
      {
        title: "Product Delay",
        icon: <img src={ProductionDelayIcon} alt="Production Delay" />,
        link: "/production/product-delay",
        id: "",
        users: ["Admin", "AirvectorCustomer", "Manager"],
      },
      {
        title: "HSW",
        icon: <HealthAndSafetyIcon style={{ color: "#737373" }} />,
        link: "/production/hsw",
        id: "",
        users: ["Admin", "AirvectorCustomer", "Manager"],
      },
      {
        title: "Master Performance Dashboard",
        icon: <img src={MasterDashIcon} alt="MasterDashIcon" />,
        link: Routes.MasterDash,
        id: "",
        users: ["Admin", "AirvectorCustomer", "Manager", "Mechanic"],
      },
    ],
  },
  {
    title: "Customer Service",
    icon: <SupportAgentIcon style={{ color: "#737373", fontSize: "40px" }} />,
    link: Routes.CustomerService,
    id: "active",
    users: ["Admin", "AirvectorCustomer", "Manager"],
    subSections: [
      {
        title: "Onboarding",
        icon: <img src={OnboardingIcon} alt="OnboardingIcon" />,
        link: Routes.Onboarding,
        id: "",
        users: ["Admin", "AirvectorCustomer", "Manager", "Mechanic"],
      },
    ],
  },


  /*Should it be hidden?*/
  /* 
    {
        title: "Sales",
        icon: <SalesIcon />,
        link: "/sales",
        id: "hiddenTab"
    },
    {
        title: "Machine status",
        icon: <MachineStatusIcon />,
        link: "/machineStatus",
        id: "hiddenTab"
    },
    {
        title: "Accountings",
        icon: <AccountingIcon />,
        link: "/accountings",
        id: "hiddenTab"
    }, */
];
